// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"742719e5","453":"1bd1e97a","591":"ce8817d9","680":"421b6b7f"}[chunkId] + ".chunk.js";
};